export default "__VITE_ASSET__C2BeEH_y__"